import { CoordinationCardSelf } from 'data/models/CoordinationCardSelf';
import { CoordinationCardRelevance, CoordinationCardRelevanceOptions } from 'data/models/CoordinationCardRelevance';

import { PCCache } from 'data/PCCache';

import { Entrypoints } from 'core/app/entrypoints';

import { LogUpdater, LogUpdaterParams } from 'portcall/eventlog/logupdater';

const LOG_REFRESH_SECONDS = 20;

export interface CoordinationCardLogUpdaterParams {
    CoordinationCardSelf : CoordinationCardSelf;
}

export type CoordinationCardLogUpdater = ReturnType<typeof CoordinationCardLogUpdater>;
export function CoordinationCardLogUpdater(
    entrypoints : Entrypoints,
    data : PCCache,
    logUpdaterModel : (params : LogUpdaterParams<CoordinationCardRelevance, CoordinationCardRelevanceOptions>) => LogUpdater,
    { CoordinationCardSelf } : CoordinationCardLogUpdaterParams
) {
    return logUpdaterModel({
        collection: data.CoordinationCardRelevances,
        url: ({ NeedSince }) => entrypoints.CoordinationCardLog({ Id: CoordinationCardSelf.Id(), NeedSince }),
        refreshSeconds: LOG_REFRESH_SECONDS
    });
}



// WEBPACK FOOTER //
// ./apps/portcall/coordinationcarddetails/logupdater.ts